import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './styles.less';
import { Content } from 'antd/es/layout/layout';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import useMobileBreakpoint from '../../../../hooks/useMobileBreakpoint';

const TriptychLayoutContent = ({ children, noPadding }) => {
  const screens = useBreakpoint();

  const hasSmallPadding = !screens.xl;

  const isMobile = useMobileBreakpoint();

  const className = classNames('triptych-layout__content', {
    'triptych-layout__content--no-padding': noPadding,
    'triptych-layout__content--small-padding': (isMobile || hasSmallPadding) && !noPadding,
    'triptych-layout__content--mobile': isMobile,
  });

  return <Content className={className}>{children}</Content>;
};

TriptychLayoutContent.propTypes = {
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
};

TriptychLayoutContent.defaultProps = {
  noPadding: false,
};

export default TriptychLayoutContent;
